import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const BG_IMG =
  "https://images.unsplash.com/photo-1611168935847-4bf3f7291cde?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxtZXJjZWRlcyUyMHN1diUyMGRhcmt8ZW58MHx8fHwxNzgxMTcyNjMyfDA&ixlib=rb-4.1.0&q=85";

export const FinalCTA = () => {
  return (
    <section className="relative py-24 sm:py-32 overflow-hidden border-t border-white/5" data-testid="final-cta-section">
      <div className="absolute inset-0">
        <img src={BG_IMG} alt="" className="w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]" />
      </div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[500px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(212,175,55,0.15) 0%, transparent 65%)" }}
      />

      <div className="relative max-w-5xl mx-auto px-6 sm:px-10 lg:px-16 text-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
        >
          <span className="text-xs uppercase tracking-[0.32em] text-[#D4AF37]">Tu próximo vehículo te espera</span>
          <h2 className="font-heading mt-6 text-3xl sm:text-5xl lg:text-6xl font-extralight tracking-tight text-[#FFFFF0] leading-[1.1] max-w-4xl mx-auto">
            Encuentra tu próximo coche en Alemania con un proceso{" "}
            <span className="italic gold-text font-light">claro, seguro y profesional.</span>
          </h2>

          <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="#contacto"
              data-testid="final-cta-primary"
              className="group relative overflow-hidden inline-flex items-center justify-center gap-3 bg-[#D4AF37] text-black px-10 py-5 text-sm uppercase tracking-[0.2em] font-medium hover:bg-[#E5C158] transition-all duration-300 cta-pulse"
            >
              <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/40 to-transparent" />
              <span className="relative">Hablar con Elecars</span>
              <ArrowRight className="relative w-4 h-4 group-hover:translate-x-1.5 transition-transform duration-300" strokeWidth={1.5} />
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
